module.exports = __webpack_public_path__ + "img/2.5f3993d0.jpg";